<template>
  <BuilderWrapper
    popout
    title="Field Settings"
    helpful-tip="Customise the fields imported from your CSV. Change display name, type, unit and totals."
    ok-only
  >
    <DefineFields :field-map="fieldMap" />
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import DefineFields from '@/components/builder/FieldSettings/DefineFields.vue'
import { FieldMapItem, FieldCalculationV2Config } from '@/types'
// @ts-ignore vuex-map-fields import
import { mapMultiRowFields } from 'vuex-map-fields'

const components = {
  BuilderWrapper,
  DefineFields,
}

@Component({
  components,
  computed: {
    // https://github.com/maoberlehner/vuex-map-fields#multi-row-fields
    ...mapMultiRowFields('primaryApp', ['appState.config.fieldMap']),
  },
})
export default class FieldSettings extends Vue {
  fieldMap!: (FieldMapItem | FieldCalculationV2Config)[]
}

</script>
